import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { StubsService } from '../Services/stubs.service';
import { Service } from '../models/service.model';
import { TemplateDetailsComponent } from '../template-details/template-details.component';
import { SharedData } from '../shared-data/shared-object.service';
import { AuthenticationService } from '../Services/authentication.service'
import { empty } from 'rxjs/Observer';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-service-details',
  templateUrl: './service-details.component.html',
  styleUrls: ['./service-details.component.css']
  // providers: [SharedData]
})
export class ServiceDetailsComponent implements OnInit {
  public identifierTypes: string[] = ['header', 'cookie'];
  public DefualtidentifierTypes: string[] = ['header', 'cookie'];
  public cookieDataTypes: string[] = ['string', 'pairs'];
  public cookieEncodingTypes: string[] = ['none', 'base64'];
  public urlMethods: string[] = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'HEAD'];
  public identifiers: any[];
  public contentTypes = ['-- any --', 'application/json', 'application/x-www-form-urlencoded']
  public type = '';
  public defaultCategory = '';
  public cookiesIdentifiers: any[] = [];
  public item: any = {};
  public tableFlag: boolean;
  public rowIndex: number;
  public serviceName: string;
  public pageMode: string = 'Add';
  public service: any = {};
  public identifier: any = {};
  public showSuccesOverLay: boolean = false;
  public showFailOverLay: boolean = false;
  public contentAdded: boolean = false;
  private urlPrefix: String;
  public isUrlExistsError: boolean = false;
  public updateValue: string = '';
  public messageHeader: string = '';
  public category: any = [];
  public newCategory: string = '';
  public updatedCategoryId: number;
  public serviceNameValid: boolean;
  public newCategoryAdded: boolean;
  public enabledSendButton: boolean;
  public messageConfirmatinBool: boolean;
  public messaggeConirmationAppear: boolean;
  public enabledUpdateButton: boolean;
  public selectedCategories: any = [];
  public showCategoriesMenu: boolean;
  public tableVanish: boolean;
  public clonedCategory: any[] = [];
  public allCategories: any[] = [];
  public backenderror = null;
  public urlMethod: string = '';
  public showTable: boolean = true;
  public lastUpdatedBy: string;

  constructor(private _stubsService: StubsService, private _route: ActivatedRoute,
    private _router: Router, private _sharedData: SharedData, private authService: AuthenticationService) {
  }

  ngOnInit(): void {
    if(environment.ssoMode) {
        this.urlPrefix = this.authService.currentUser.selectedInstance.baseUrl;
    } else {
      this.authService.currentUser.selectedInstance = this.authService.currentUser.instances[0];
      this.urlPrefix = this.authService.currentUser.selectedInstance.baseUrl;
    }
    this.service.serviceTemplates = [];
    this.identifiers = [];
    this.tableFlag = true;

    if (this._route.snapshot.params['serviceName']) {
      this.serviceName = this._route.snapshot.params['serviceName'];
      this.pageMode = 'Edit';
      this.LoadServiceData();
    }
    if (this.pageMode == 'Add') {
      this._stubsService.getCategories().subscribe((res) => {
        this.allCategories = res.json();
        this.clonedCategory = res.json();
      });

      this.setUrLMethodAndContentType();
    }
  }

  getValueById(id) {
    const item = this.allCategories.find((category) => category._id == id);
    return item && item.value;
  }
  showTemplates(templates): void {
    for (let temp of templates) {
      this.service.serviceTemplates.push(temp);
    }
  }

  LoadServiceData(): void {
    const service = this._sharedData.getService(this.serviceName);
    if (service && service.serviceTemplates) {
      this.service = this._sharedData.getService(this.serviceName);
      if (this.service.urlPath.includes(this.urlPrefix)) {
        this.service.urlPath = this.service.urlPath.replace(this.urlPrefix, '');
      }
      this.service.identifiers.forEach(identifer => {
        if (identifer.queryType == 'cookie') {
          this.cookiesIdentifiers.push(identifer);
        } else {
          this.identifiers.push(identifer);
        }
      });

      this.getCategories();

      this.setUrLMethodAndContentType();
    } else {

      this._stubsService.getServiceByName(this.serviceName)
        .subscribe(serviceData => {

          this._sharedData.setService(serviceData);
          this.service = serviceData;

          if (this.service.urlPath.includes(this.urlPrefix)) {
            this.service.urlPath = this.service.urlPath.replace(this.urlPrefix, '');
          }

          this.service.identifiers.forEach(identifer => {
            if (identifer.queryType === 'cookie') {
              this.cookiesIdentifiers.push(identifer);
            } else {
              this.identifiers.push(identifer);
            }
          });

          this.getCategories();

          this.setUrLMethodAndContentType();

        }, error => console.log(error));
    }
    // get user by id and save the user name id the user exists 
    if (this.service.lastUpdatedBy) {
      this._stubsService.getUserById(this.service.lastUpdatedBy).subscribe((resp) => {
        this.lastUpdatedBy = resp.user.email;
      });
    }
  }

  setUrLMethodAndContentType() {
    if (this.service.urlMethod) {
      this.urlMethod = this.service.urlMethod.toUpperCase();
    }
    if (this.service.contentType) {
      this.type = this.service.contentType
    }
    if (this.service.contentType) {
      if (this.service.contentType == 'application/json') {
        this.contentTypes.splice(this.contentTypes.indexOf('application/x-www-form-urlencoded'))
      } else if (this.service.contentType == 'application/x-www-form-urlencoded') {
        this.contentTypes.splice(this.contentTypes.indexOf('application/json'))
      }
    }
  }

  getCategories() {
    this._stubsService.getCategories().subscribe((res) => {
      // ToBeChekced
      if (this.service.category && typeof this.service.category[0] === 'string') {

        this.selectedCategories = this.service.category ? this.service.category : [];
      } else {

        this.selectedCategories = this.service.category ? this.service.category.filter(((category) => category._id))
          .map((category) => category._id) : [];
      }
      this.allCategories = res.json();
      this.clonedCategory = res.json();
    });
  }

  submitForm(form: any, isValid: boolean): void {

    const regex = new RegExp(`^([A-Za-z0-9]+)_(GET|POST|DELETE|PUT|PATCH|HEAD)$`);
    if (this.pageMode == 'Add' && !regex.test(this.service._id)) {
      return;
    }
    if (this.service.urlPath && this.service.urlPath.match(this.urlPrefix)) {
      this.service.urlPath = form.urlPath;
    } else {
      this.service.urlPath = this.urlPrefix + form.urlPath;
    }

    this.service.urlPath = this.service.urlPath.replace('//', '/');

    this.service.urlMethod = form.urlMethod;

    this.service.isDeleted = "false";

    this.service.identifiers = this.identifiers.concat(this.cookiesIdentifiers);

    this.service.serviceTemplates = this.service.serviceTemplates;

    this.service.lastUpdatedBy = this.authService.getCurrentUser()._id;

    this.service.lastUpdateDate = new Date().getTime();

    this.contentAdded = true;

    this.type != '-- any --' ? this.service.contentType = this.type : this.service.contentType = '';

    if (this.pageMode == 'Add') {

      this._stubsService.CreateServiceTemplate(this.service, this.selectedCategories)
        .subscribe(response => {
          this.service.category = [...this.selectedCategories];
          this._sharedData.setService(this.service);
        },
          error => {
            this.showFailOverLay = true;
            this.backenderror = error;
            console.log(error);
          });
    } else if (this.pageMode == 'Edit') {
      this._stubsService.UpdateServiceTemplate(this.service, this.service._id, this.selectedCategories)
        .subscribe(response => {
          this.service.category = [...this.selectedCategories];
          this._sharedData.setService(this.service)
        },
          error => {
            this.backenderror = error;
            this.showFailOverLay = true;
            console.log(error);
          });
    } else {

    }
  }
  public checkedCategory(cat, i, id) {

    const categoryIndex = this.selectedCategories.findIndex((categoryId) => categoryId == id);
    if (categoryIndex === -1 && id) {
      this.selectedCategories.push(id);
    } else if (categoryIndex >= 0 && id) {
      this.selectedCategories.splice(categoryIndex, 1);
    }
  }

  deleteTemplate(item): void {
    this.service.serviceTemplates.splice(item, 1);
  }
  passData(object) {

  }
  addTemplate() {

  }

  editTemplate(template): void {

    let templateNewObj = {
      "code": template.code,
      "defaultBody": template.template.defaultBody,
      "bodyTemplate": template.template.ServiceBodyTemplate
    }
  }

  checkValidCookieName(cookieName) {
    return true;
  }

  checkValidCookieIdentifier(cookie) {

    var validCookieConfigurationFlag: boolean = cookie.name && this.checkValidCookieName(cookie.name) && cookie.cookieDataType && cookie.cookieEncodingType;

    return (cookie.cookieDataType == 'pairs') ?
      (validCookieConfigurationFlag && cookie.cookieIdentifierKey) :
      (validCookieConfigurationFlag);
  }

  addIdentifier(form: any, i) {

    var item: any = {};

    if (i.queryType == 'jsonPath') {
      item = {
        "name": i.name,
        "queryType": i.queryType,
        "value": i.jsonPath
      };
      this.identifiers.push(item);
    } else if (i.queryType == 'cookie') {

      var cookieIdentifier: any = {
        cookieDataType: i.cookieDataType,
        cookieEncodingType: i.cookieEncodingType,
        name: i.name,
        queryType: i.queryType,
      };

      if (i.cookieDataType == 'pairs') {
        cookieIdentifier.cookieIdentifierKey = i.cookieIdentifierKey;
      }

      if (this.checkValidCookieIdentifier(cookieIdentifier)) {
        this.cookiesIdentifiers.push(cookieIdentifier);
      } else {
        alert('not valid cookie identifier');
        return;
      }
    } else {
      item = {
        "name": i.name,
        "queryType": i.queryType
      };
      this.identifiers.push(item);
    }

    this.item = {};
  }

  deleteIdentifier(i) {
    this.identifiers.splice(i, 1);
  }

  updateIdentifier(form: any, i) {
    this.tableFlag = false;
    this.rowIndex = i;
    this.item.name = this.identifiers[i].name;
    this.item.queryType = this.identifiers[i].queryType;
    if (this.identifiers[i].queryType == 'jsonPath') {
      document.getElementById("jpCheck").style.display = "block";
      this.item.jsonPath = this.identifiers[i].value;
    } else {
      document.getElementById("jpCheck").style.display = "none";
      delete this.identifiers[this.rowIndex].value;
    }
  }

  updateCookieIdentifier(form: any, i) {
    this.tableFlag = false;
    this.rowIndex = i;
    this.item.name = this.cookiesIdentifiers[i].name;
    this.item.queryType = this.cookiesIdentifiers[i].queryType;
    document.getElementById("jpCheck").style.display = "none";
    this.item.cookieDataType = this.cookiesIdentifiers[i].cookieDataType;
    this.item.cookieIdentifierKey = this.cookiesIdentifiers[i].cookieIdentifierKey;
    this.item.cookieEncodingType = this.cookiesIdentifiers[i].cookieEncodingType;

  }

  deleteCookieIdentifer(i) {
    this.cookiesIdentifiers.splice(i, 1);
  }

  handleCookieUpdate() {

    var cookieIdentifier: any = {
      cookieDataType: this.item.cookieDataType,
      cookieEncodingType: this.item.cookieEncodingType,
      name: this.item.name,
      queryType: this.item.queryType
    };

    if (this.item.cookieDataType == 'pairs') {
      cookieIdentifier.cookieIdentifierKey = this.item.cookieIdentifierKey;
    }

    if (this.checkValidCookieIdentifier(cookieIdentifier)) {
      this.cookiesIdentifiers[this.rowIndex] = cookieIdentifier;
      this.item = {};
      this.tableFlag = true;
    }
    else {
      alert('not valid cookie identifier');
    }

  }

  updateRow(form: any) {

    if (this.item.queryType == 'cookie') {
      this.handleCookieUpdate();
      return;
    }

    this.identifiers[this.rowIndex].name = form.identifierName;
    this.identifiers[this.rowIndex].queryType = this.item.queryType;

    if (this.item.queryType == 'jsonPath') {
      this.identifiers[this.rowIndex].value = form.identifierjPath;

    } else {
      document.getElementById("jpCheck").style.display = "none";
      delete this.identifiers[this.rowIndex].value
    }
    this.tableFlag = true;
    this.item.name = '';
    this.item.queryType = '';
    this.item.jsonPath = '';
  }

  addCategory() {

    const newCategory = this.newCategory.trim().toLocaleLowerCase();

    const isCategoryExist = this.allCategories.filter((category) => category.value.toLowerCase() === newCategory)[0];

    if (!isCategoryExist && newCategory !== '') {
      this._stubsService.createCategory(newCategory).subscribe((res) => {
        res = res.json();
        this.allCategories.push(res);
        this.newCategory = '';
        this.newCategoryAdded = true;
      });
    } else if (isCategoryExist) {

      this.showFailOverLay = true;

      this.messageHeader = 'Category Already Exist';

      this.backenderror = 'Category with same name is already exist';
    }
  }
  showCheckboxes() {
    this.showCategoriesMenu = !this.showCategoriesMenu;
  }
  startEditingCategory(catValue, categoryId) {

    this.newCategory = catValue;

    this.updatedCategoryId = categoryId;
  }
  updateCategory() {
    const newCategory = this.newCategory.trim().toLocaleLowerCase();
    const isCategoryExist = this.allCategories.filter((category) => category.value.toLowerCase() === newCategory)[0];
    if (!isCategoryExist && newCategory.trim() !== '') {
      this.showTable = false;
      this._stubsService.updateCategory(this.updatedCategoryId, newCategory).subscribe((res) => {
        this.newCategory = '';
        res = res.json();
        const categoryIndex = this.allCategories.findIndex((category) => category._id === this.updatedCategoryId);
        if (categoryIndex >= 0) {
          this.allCategories[categoryIndex].value = newCategory;
        }
        this.showTable = true;
        this.updatedCategoryId = null;
      });
    } else if (isCategoryExist) {
      this.showFailOverLay = true;
      this.messageHeader = 'Category Already Exist';
      this.backenderror = 'Category with same name is already exist';
    }
  }
  deleteCategoryFromAllServices(categoryId) {
    this.messageConfirmatinBool = true;
    this.messaggeConirmationAppear = true;
    // this.showCategoriesMenu = false;
    if (this.messageConfirmatinBool) {

      this._stubsService.removeCategory(categoryId).subscribe((res) => {
        this.deleteCategoryFromService(categoryId);
      });
    }
    this.allCategories = this.allCategories.filter((category) => category._id !== categoryId);
    this.messageConfirmatinBool = false;
  }
  deleteCategoryFromService(categoryId) {
    const categoryIndex = this.selectedCategories.findIndex((_categoryId) => _categoryId == categoryId);
    if (categoryIndex >= 0) {
      this.selectedCategories.splice(categoryIndex, 1);
    }
  }
  serviceNameValidition() {
    const regex = new RegExp(`^([A-Za-z0-9]+)_(GET|POST|DELETE|PUT|PATCH|HEAD)$`);
    this.serviceNameValid = regex.test(this.service._id)
    return this.serviceNameValid;
  }

  submitFormAndAddTemplate(form: any, isValid: boolean): void {
    const regex = new RegExp(`^([A-Za-z0-9]+)_(GET|POST|DELETE|PUT|PATCH|HEAD)$`);
    if (this.pageMode != 'Edit' && !regex.test(this.service._id)) {
      return;
    }
    if (this.service.urlPath && this.service.urlPath.match(this.urlPrefix)) {
      this.service.urlPath = form.urlPath;
    } else {
      this.service.urlPath = this.urlPrefix + form.urlPath;
    }
    this.service.urlPath = this.service.urlPath.replace('//', '/');
    this.service.urlMethod = form.urlMethod;
    this.service.isDeleted = "false";
    this.service.lastUpdateDate = new Date().getTime();
    this.contentAdded = true;
    this.service.identifiers = this.identifiers.concat(this.cookiesIdentifiers);
    this.service.serviceTemplates = this.service.serviceTemplates;
    if (this.pageMode == 'Add') {
      this._stubsService.CreateServiceTemplate(this.service, this.selectedCategories)
        .subscribe(response => {
          this.isUrlExistsError = false;
          this.service.category = [...this.selectedCategories];
          this._sharedData.setService(this.service);
          this._router.navigate(['templatedetails/', this.service._id]);
        },
          error => {
            this.isUrlExistsError = true;
            this.showFailOverLay = true;
            this.backenderror = error;
            console.log(error)
          });
    } else if (this.pageMode == 'Edit') {
      this._stubsService.UpdateServiceTemplate(this.service, this.service._id, this.selectedCategories)
        .subscribe(response => {
          this.isUrlExistsError = false;
          this.service.category = [...this.selectedCategories];
          this._sharedData.setService(this.service);
          this._router.navigate(['templatedetails/', this.serviceName]);
        },
          error => {
            this.isUrlExistsError = true;
            this.backenderror = error;
            this.showFailOverLay = true;
            console.log(error)
          });
    }
  }

  isIdentifiersvalid(item) {

    if (!item.name || !item.queryType) {
      return false;
    }
    if (item.queryType == 'jsonPath') {
      return item.jsonPath ? item.jsonPath.match('^(?=[\$.])(.{1,2000})(?:[^-\\s])$') : false
    } else if (item.queryType == 'cookie') {
      var cookieIdentifier: any = {
        cookieDataType: item.cookieDataType,
        cookieEncodingType: item.cookieEncodingType,
        name: item.name,
        queryType: item.queryType,
      };

      if (item.cookieDataType == 'pairs') {
        cookieIdentifier.cookieIdentifierKey = item.cookieIdentifierKey;
      }
      return this.checkValidCookieIdentifier(cookieIdentifier)
    }

    return true;
  }

  loadIdentifiersFromSpecNames() {

    this.identifiers = this.identifiers.filter((identifier) => this.DefualtidentifierTypes.indexOf(identifier.queryType) >= 0);

    this._stubsService
      .getIdentifiersFromSpecName(this.service._id)
      .subscribe((data) => {

        if (Array.isArray(data)) {

          if (!data.length) {

            this.showFailOverLay = true;

            this.backenderror = 'Please add your identifier in automation spec names';

            this.messageHeader = 'No identifiers are detected for this service name';
          }

          data.forEach((identifier) => {

            if (identifier.specName !== 'Peter-Donald-Daisy-Della-Robert Msisdn' && identifier.queryType) {

              const mappedIdentifier = {
                "name": identifier.name,
                "queryType": identifier.queryType,
                "value": identifier.bodyJsonPath
              };

              this.identifiers.push(mappedIdentifier);
            }
          });
        }
      }, (error) => {

        this.showFailOverLay = true;

        this.backenderror = error;
      });
  }


  removeIdentifiersFromSpecNames() {

    this.identifiers = this.identifiers.filter((identifier) => this.DefualtidentifierTypes.indexOf(identifier.queryType) >= 0);
  }

  hasSpecNameIdentifier() {

    return this.identifiers.filter((identifier) => this.DefualtidentifierTypes.indexOf(identifier.queryType) === -1).length > 0;
  }

  failureIsConfirmed() {

    this.showFailOverLay = false;

    this.backenderror = null;

    this.messageHeader = null;
  }

  closeOverLays() {

    this.newCategoryAdded = false;
  }
}








// WEBPACK FOOTER //
// ./src/app/service-details/service-details.component.ts